import { LocalLessonProviderData } from "@jelly/lesson";
import course01 from "./course-01";
import course02 from "./course-02";
import course03 from "./course-03";
import course04 from "./course-04";
import course05 from "./course-05";

const data: LocalLessonProviderData = {
  byId: {
    ...course01.byId,
    ...course02.byId,
    ...course03.byId,
    ...course04.byId,
    ...course05.byId,
  },
  linksById: {
    ...course01.linksById,
    ...course02.linksById,
    ...course03.linksById,
    ...course04.linksById,
    ...course05.linksById,
  },
};

export default data;
